export default "__VITE_ASSET__B3E18DcP__"